import React from 'react';
import { ChevronRightIcon, DownloadIcon, FileTextIcon, LeafIcon, PackageIcon, RecycleIcon, Share2Icon, SparklesIcon, SproutIcon, Trash2Icon } from 'lucide-react';
import { categories, collectionsByDate, formatLongDate, toKey, type CategoryId } from '../../data/calendrierCollectes';
const icons: Record<CategoryId, typeof RecycleIcon> = {
  recyclage: RecycleIcon,
  dechets: Trash2Icon,
  organiques: LeafIcon,
  jardin: SproutIcon,
  lourds: PackageIcon,
  speciales: SparklesIcon
};
interface DayDetailsProps {
  date: Date;
}
export function DayDetails({
  date
}: DayDetailsProps) {
  const events = collectionsByDate[toKey(date)] ?? [];
  return <section aria-live="polite" aria-labelledby="day-title" data-id="element-676" data-mp="16q86snac0ww">
      <h2 id="day-title" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-677" data-mp="651mbfkm4xkx">
        {formatLongDate(date)}
      </h2>

      {events.length === 0 ? <p className="mt-4 rounded-2xl border border-dashed border-slate-200 bg-slate-50 px-5 py-6 text-sm text-slate-500" data-id="element-678" data-mp="2qwafhdnewkcr">
          No collection scheduled at your address that day.
        </p> : <ul className="mt-4 space-y-3" data-id="element-679" data-mp="2osgf0p7ew1bb">
          {events.map(id => {
        const category = categories[id];
        const Icon = icons[id];
        return <li key={id} data-id="element-680" data-mp="2xscwa5rh1xwc">
                <button type="button" className="flex w-full items-center gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4 text-left transition-colors duration-150 ease-ville hover:border-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-681" data-mp="2xslaq238tb9n">
                  <span className={`grid h-11 w-11 shrink-0 place-items-center rounded-xl ${category.chip}`} aria-hidden="true" data-id="element-682" data-mp="32pv8c50sct8k">
                    <Icon className="h-5 w-5" data-id="element-683" data-mp="3gjm8wnwjh2s5" />
                  </span>
                  <span className="min-w-0 flex-1" data-id="element-684" data-mp="3cgpvdbluvwv2">
                    <span className="block font-bold uppercase tracking-wide text-ville-navy" data-id="element-685" data-mp="3qfft8tgi20kh">{category.label}</span>
                    <span className="block text-sm text-slate-500" data-id="element-686" data-mp="3lhnt5c5pb857">{category.time}</span>
                  </span>
                  <ChevronRightIcon className="h-5 w-5 shrink-0 text-slate-400" aria-hidden="true" data-id="element-687" data-mp="2j4rhtzz9s67j" />
                </button>
              </li>;
      })}
        </ul>}

      <div className="mt-5 flex flex-wrap gap-2" data-id="element-688" data-mp="2s4ejmmvwve14">
        {[{
        label: 'PDF',
        Icon: FileTextIcon
      }, {
        label: 'Download',
        Icon: DownloadIcon
      }, {
        label: 'Share',
        Icon: Share2Icon
      }].map(({
        label,
        Icon
      }) => <button key={label} type="button" className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-689" data-mp="36t0yyoljg5sc">
            <Icon className="h-4 w-4" aria-hidden="true" data-id="element-690" data-mp="1ghoawgy9izrv" />
            {label}
          </button>)}
      </div>
    </section>;
}